// Estado do questionário de onboarding da lista de espera (spec-001, T013).
// Fábrica (não objeto literal) para dar isolamento real a cada teste/registro do módulo —
// mesma receita de `ai-framework/store/approvals.js`.
export default () => ({
  // Espelho de `contracts/questionario-estado.json#/properties/value` — nunca redeclare
  // o shape aqui, ele vem inteiro do servidor em toda resposta (GET/PUT/POST).
  campoAtual: null, // um de nome|email_contato|telefone|auc_texto|numero_clientes_texto|empresa|corretoras_texto|concluido
  respostas: {}, // campo confirmado → valor; campo AUSENTE = ainda não respondido (nunca string vazia)
  revisao: 0, // devolvida em toda escrita seguinte (AC-2.4)
  posicao: null, // null até concluir; nunca recalculada no cliente (AC-3.3)
  concluido: false,
  perguntas: [], // ordem fixa vinda do servidor — o front não a redeclara

  // ★ [21/09/2026 — contracts/etapas-do-questionario.md] O AGRUPAMENTO É DO SERVIDOR.
  // `etapas` é `[{id, titulo, indice, total}]` e `etapaAtual` é o id da corrente. O
  // front NUNCA redeclara nem deriva a lista: uma fonte de verdade, como já vale para
  // `perguntas`. Vazio enquanto o servidor não mandar — e vazio a tela não desenha
  // etapa nenhuma, de propósito (um fallback com a lista escrita aqui seria a segunda
  // fonte que o contrato existe para impedir).
  etapas: [],
  etapaAtual: null,

  // Dado da TELA, não do servidor — nunca sobrescrito por SET_ESTADO (é o que garante
  // não perder a digitação corrente quando um 409 dispara um re-fetch, T013).
  //
  // ★ MAPA `campo → texto`, e não uma string só: desde a v2 a pessoa preenche a ETAPA
  // inteira antes de qualquer PUT, então há uma digitação em curso POR CAMPO. Cada
  // campo confirmado sai do mapa (`LIMPAR_RASCUNHO`); os que ainda não foram gravados
  // continuam ali, que é exatamente o que sobrevive ao 409 no meio da sequência.
  rascunho: {},

  loading: false, // GET em andamento (T013: carregar)
  enviando: false, // PUT/POST em andamento — trava o botão (hard rule de UX do repo)
  erro: null, // mensagem da última falha de gravação; AC-2.3 mantém a pergunta corrente
})
